<template>
  <div class="CloudStorage">
    <el-container>
      <el-header>
        <h1 v-if="currentView === 'list'">云存档用户列表</h1>
        <h1 v-else>用户 {{ selectedUser?.username }} 的云存档</h1>
      </el-header>

      <el-main>
        <!-- 一级界面：用户列表 -->
        <div v-if="currentView === 'list'">
          <el-input
            v-model="searchQuery"
            placeholder="搜索用户名、SteamID3或游戏名"
            @input="currentPage = 1"
            clearable
            prefix-icon="el-icon-search"
            style="margin-bottom: 20px; width: 100%;"
          />
<div class="table-container">
          <el-table :data="paginatedUsers" style="width: 100%;" border>
            <el-table-column prop="username" label="用户名"></el-table-column>
            <el-table-column prop="steamid3" label="SteamID3"></el-table-column>
            <el-table-column prop="count" label="存档数" width="100"></el-table-column>
<el-table-column prop="cloudStorge_safe" label="状态" width="100">
  <template #default="scope">
    <el-tag type="success" v-if="scope.row.cloudStorge_safe == 0">正常</el-tag>
    <el-tag type="danger" v-else>封禁</el-tag>
  </template>
</el-table-column>

            <el-table-column prop="game_title" label="关联游戏"></el-table-column>
            <el-table-column label="占用空间 (MB)">
              <template #default="scope">
                {{ scope.row.storage_MB.toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column prop="upload_new_time" label="最近上传时间"></el-table-column>
            
           <el-table-column label="操作">
  <template #default="scope">
    <div class="action-buttons">
      <el-button type="primary" size="small" @click="openUser(scope.row)">
        查看存档
      </el-button>
      <el-button
        :type="scope.row.cloudStorge_safe == 0 ? 'danger' : 'success'"
        size="small"
        @click="toggleBan(scope.row)"
      >
        {{ scope.row.cloudStorge_safe == 0 ? "封禁存档" : "解封存档" }}
      </el-button>
    </div>
  </template>
</el-table-column>

          </el-table>
          </div>

          <el-pagination
            background
            layout="prev, pager, next"
            :total="totalPages * pageSize"
            :page-size="pageSize"
            v-model:currentPage="currentPage"
            @current-change="fetchUsers"
            style="margin-top: 20px; text-align: center;"
          ></el-pagination>
        </div>

        <!-- 二级界面：用户存档详情 -->
        <div v-else>
          <el-button type="default" @click="goBack" style="margin-bottom: 20px;">
            返回
          </el-button>
          <el-table :data="archives" style="width: 100%;" border>
            <el-table-column prop="gameName" label="存档名称"></el-table-column>
            <el-table-column label="大小 (MB)">
              <template #default="scope">
                {{ (scope.row.fileSize / 1024).toFixed(2) }}
              </template>
            </el-table-column>
            <el-table-column prop="lastUpdate" label="上传时间"></el-table-column>
            <el-table-column prop="download_new_time" label="最近下载"></el-table-column>
            <el-table-column prop="status" label="状态">
              <template #default="scope">
                <el-tag type="success" v-if="scope.row.status == 0">正常</el-tag>
                <el-tag type="danger" v-else>禁用</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template #default="scope">
                <el-button type="danger" size="small" @click="deleteArchive(scope.row)">
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-main>
    </el-container>
  </div>
</template>

<script>
import axios from "../axios";

export default {
  name: "CloudStorage",
  data() {
    return {
      currentView: "list",
      users: [],
      archives: [],
      selectedUser: null,
      searchQuery: "",
      currentPage: 1,
      pageSize: 20
    };
  },
  computed: {
    filteredUsers() {
      if (!this.searchQuery) return this.users;
      const q = this.searchQuery.toLowerCase();
      return this.users.filter(
        u =>
          (u.username && u.username.toLowerCase().includes(q)) ||
          (u.steamid3 && u.steamid3.toLowerCase().includes(q)) ||
          (u.game_title && u.game_title.toLowerCase().includes(q))
      );
    },
    paginatedUsers() {
      const start = (this.currentPage - 1) * this.pageSize;
      const end = start + this.pageSize;
      return this.filteredUsers.slice(start, end);
    },
    totalPages() {
      return Math.ceil(this.filteredUsers.length / this.pageSize);
    }
  },
  created() {
    this.fetchUsers();
  },
  methods: {
    async fetchUsers() {
      try {
        const token = localStorage.getItem("user-token");
        const response = await axios.post("/index.php?action=getCloudUsers", {
          token,
          search: this.searchQuery
        });
        this.users = response.data.users.map(u => ({
          ...u,
          storage_MB: u.storage ? u.storage / 1024 : 0
        }));
      } catch (err) {
        console.error(err);
        this.users = [];
      }
    },
    async openUser(user) {
      this.selectedUser = user;
      this.currentView = "detail";
      await this.fetchArchives(user);
    },
    async fetchArchives(user) {
      try {
        const token = localStorage.getItem("user-token");
        const response = await axios.post("/index.php?action=getUserArchives", {
          token,
          username: user.username
        });
        this.archives = response.data.archives || [];
      } catch (err) {
        console.error(err);
        this.archives = [];
      }
    },
    goBack() {
      this.currentView = "list";
      this.selectedUser = null;
      this.archives = [];
    },
    async deleteArchive(archive) {
      try {
        const token = localStorage.getItem("user-token");
        const response = await axios.post("/index.php?action=deleteArchive", {
          token,
          archiveId: archive.id
        });
        if (response.data.success) {
          this.$message.success("存档已删除");
          await this.fetchArchives(this.selectedUser);
        } else {
          this.$message.error(response.data.message || "删除失败");
        }
      } catch (err) {
        console.error(err);
        this.$message.error("操作失败，请稍后重试");
      }
    },
    async toggleBan(user) {
      try {
        const token = localStorage.getItem("user-token");
        const response = await axios.post("/index.php?action=toggleCloudBan", {
          token,
          username: user.username,
          ban: user.cloudStorge_safe == 0 ? 1 : 0
        });
        if (response.data.success) {
          this.$message.success(response.data.message);
          this.fetchUsers();
        } else {
          this.$message.error(response.data.message || "操作失败");
        }
      } catch (err) {
        console.error(err);
        this.$message.error("操作失败，请稍后重试");
      }
    }
  }
};
</script>

<style scoped>
.CloudStorage {
  padding: 20px;
  width: 100%;
}
.el-main {
  width: 100%;
}
.el-table {
  width: 100%;
  table-layout: fixed; /* 列宽固定 */
}

.table-container {
  overflow-x: auto; /* 超出可横向滚动 */
}

@media (max-width: 768px) {
  .CloudStorage {
    padding: 10px;
  }
}
@media (max-width: 768px) {
  .el-table th, .el-table td {
    padding: 6px 8px;
    font-size: 12px;
  }
}

.action-buttons {
  display: flex;
  justify-content: center; /* 水平居中 */
  align-items: center;   /* 垂直居中 */
  gap: 5px;              /* 按钮间距 */
}

</style>
